import { getCurrentDateTime, isNullOrUndefined, safeInt, safeString } from './Utils';
import { ALERT_TYPE_CREDIT_DAYS, ALERT_TYPE_CREDIT_LIMIT, ALERT_TYPE_CUSTOM, ALERT_TYPE_CUSTOMER_PAYMENT_DUE, ALERT_TYPE_ITEMS_EXPIRED, ALERT_TYPE_ITEMS_EXPIRING, ALERT_TYPE_LOW_STOCK, ALERT_TYPE_OUT_OF_STOCK, ALERT_TYPE_SUPPPLIER_PAYMENT_DUE, CREDIT_NOTE_ENTITY, DEBIT_NOTE_ENTITY, EXPENSE_ENTITY, INVOICE_ENTITY, PAYMENT_ENTITY, PURCHASE_BILL_ENTITY, STOCK_ADJUSTMENT_ENTITY } from './Common';

export function getAlertNameById(alertTypeId) {
    switch (safeInt(alertTypeId)) {
        case ALERT_TYPE_CREDIT_DAYS:
            return "CREDIT_DAYS";
        case ALERT_TYPE_CREDIT_LIMIT:
            return "CREDIT_LIMIT";
        case ALERT_TYPE_CUSTOMER_PAYMENT_DUE:
            return "CUSTOMER_PAYMENT_DUE";
        case ALERT_TYPE_CUSTOM:
            return "ITEMS_CUSTOM";
        case ALERT_TYPE_ITEMS_EXPIRED:
            return "ITEMS_EXPIRED";
        case ALERT_TYPE_ITEMS_EXPIRING:
            return "ITEMS_EXPIRING";
        case ALERT_TYPE_LOW_STOCK:
            return "LOW_STOCK";
        case ALERT_TYPE_OUT_OF_STOCK:
            return "OUT_OF_STOCK";
        case ALERT_TYPE_SUPPPLIER_PAYMENT_DUE:
            return "SUPPPLIER_PAYMENT_DUE";
        default:
            break;
    }
}

export function setAuditInformation(entity, setAuditDetails) {
    try {
        setAuditDetails({
            createUserId: entity.createUserId,
            dateCreated: entity.dateCreated,
            createUserName: entity.createUserName,
            createEmailAddress: entity.createEmailAddress,

            updatedUserId: entity.updateUserId,
            dateUpdated: entity.dateUpdated,
            updateUserName: entity.updateUserName,
            updateEmailAddress: entity.updateEmailAddress,
        });
    } catch (error) {
        console.log(error);
    }
}

export function isTransactionalOperation(entityName) {
    let isTransactional = false;
    switch (entityName) {
        case INVOICE_ENTITY:
        case CREDIT_NOTE_ENTITY:
        case PURCHASE_BILL_ENTITY:
        case DEBIT_NOTE_ENTITY:
        case EXPENSE_ENTITY:
        case STOCK_ADJUSTMENT_ENTITY:
        case PAYMENT_ENTITY:
            isTransactional = true;
            break;
        default:
            isTransactional = false;
            break;
    }
    return isTransactional;
}

export function clearCacheAll(setAPIResponseCache) {
    setAPIResponseCache({
        GetDashboardInformation: null,
        GetDashboardInformationTimestamp: "",
        GetDashboardInformationLastFetchTime: null,

        GetReceivablesList: null,
        GetReceivablesListTimestamp: "",
        GetReceivablesListLastFetchTime: null,

        GetPayablesList: null,
        GetPayablesListTimestamp: "",
        GetPayablesListLastFetchTime: null,

        GetSalesListByCostCenter: null,
        GetSalesListByCostCenterTimestamp: "",
        GetSalesListByCostCenterLastFetchTime: null,

        GetCustomerLiteList: null,
        GetCustomerLiteListTimestamp: "",
        GetCustomerLiteListLastFetchTime: null,

        GetSupplierLiteList: null,
        GetSupplierLiteListTimestamp: "",
        GetSupplierLiteListLastFetchTime: null,

        ProductCategoryList: null,
        ProductCategoryListTimestamp: "",
        ProductCategoryListLastFetchTime: null,

        EmployeeList: null,
        EmployeeListTimestamp: "",
        EmployeeListLastFetchTime: null,

        ProductLiteList: null,
        ProductLiteListTimestamp: "",
        ProductLiteListLastFetchTime: null,

        ProjectList: null,
        ProjectListTimestamp: "",
        ProjectListLastFetchTime: null,
        
        GetBankDetailsList: null,
        GetBankDetailsListTimestamp: "",
        GetBankDetailsListLastFetchTime: null

    });
}

/// <summary>
/// Clears cache for a specific set of keys.
/// </summary>
/// <param name="keys">Array of keys to clear in the cache.</param>
/// <param name="apiResponseCache">The cache object containing API responses.</param>
/// <param name="setAPIResponseCache">Function to update the cache state.</param>
/// <returns>Returns nothing.</returns>
export function clearCacheByKeys(keys, apiResponseCache, setAPIResponseCache) {
    let cachedData = { ...apiResponseCache };
    keys.forEach(key => {
        cachedData[key] = null;
        cachedData[`${key}Timestamp`] = "";
        cachedData[`${key}LastFetchTime`] = null;
    });
    setAPIResponseCache(cachedData);
}

/// <summary>
/// Clears the cache for a specific key.
/// </summary>
/// <param name="key">The key to clear in the cache.</param>
/// <param name="apiResponseCache">The cache object containing API responses.</param>
/// <param name="setAPIResponseCache">Function to update the cache state.</param>
/// <returns>Returns nothing.</returns>
export function clearCacheByKey(key, apiResponseCache, setAPIResponseCache) {
    let cachedData = { ...apiResponseCache };
    cachedData[key] = null;
    cachedData[`${key}Timestamp`] = "";
    cachedData[`${key}LastFetchTime`] = null;
    setAPIResponseCache(cachedData);
}

/// <summary>
/// Checks if the data is available in cache and not expired.
/// </summary>
/// <param name="key">The key to check in the cache.</param>
/// <param name="apiResponseCache">The cache object containing API responses.</param>
/// <param name="autoRefreshRate">The auto-refresh rate in minutes (default is 30 minutes).</param>
/// <returns>Returns true if data is available in cache and not expired, otherwise false.</returns>
export function checkIfAvailableInCache(key, apiResponseCache, autoRefreshRate = 30) {
    if (isNullOrUndefined(apiResponseCache) || isNullOrUndefined(apiResponseCache[key]) || isNullOrUndefined(apiResponseCache[`${key}LastFetchTime`])) {
        return false;
    }
    let fetchFromCache = false;
    if (!isNullOrUndefined(apiResponseCache[key])) {
        const now = new Date();
        const lastFectTime = new Date(apiResponseCache[`${key}LastFetchTime`])
        const AUTO_REFRESH_IN_MINUTES = autoRefreshRate * 60 * 1000;
        fetchFromCache = (now - lastFectTime) < AUTO_REFRESH_IN_MINUTES;
    }
    return fetchFromCache;
}

export function getCachedData(key, apiResponseCache) {
    if (isNullOrUndefined(apiResponseCache) || isNullOrUndefined(apiResponseCache[key])) {
        return null;
    }
    return apiResponseCache[key];
}

export function setCacheData(key, data, apiResponseCache, setAPIResponseCache) {
    let cachedData = { ...apiResponseCache };
    cachedData[key] = data;
    cachedData[`${key}LastFetchTime`] = new Date();
    cachedData[`${key}Timestamp`] = getCurrentDateTime();
    setAPIResponseCache(cachedData);
}

/// <summary>
/// Builds an object of initial custom field values for a given entity
/// by reading `authContext.customFieldDefinitions`. Keys are fieldKey; values start as ''.
/// </summary>
/// <param name="authContext">Auth context containing customFieldDefinitions</param>
/// <param name="entityName">Entity name to filter custom fields</param>
/// <returns>Object with keys for each custom field initialized to empty string</returns>
export function getInitialCustomFieldValues(authContext, entityName) {
    try {
        let customFieldValues = {};
        if (!isNullOrUndefined(authContext) && !isNullOrUndefined(authContext.customFieldDefinitions)) {
            const entityCustomFields = authContext.customFieldDefinitions.filter(
                cfd => cfd.entityName === entityName
            );
            for (let i = 0; i < entityCustomFields.length; i++) {
                const fieldDef = entityCustomFields[i];
                customFieldValues[fieldDef.fieldKey] = fieldDef.defaultValue || '';
            }
        }
        return customFieldValues;
    } catch (error) {
        console.log('Error in getInitialCustomFieldValues: ', error);
        return {};
    }
}

/// <summary>
/// Builds custom field data array for submission from form values.
/// Extracts custom field values from the values object based on custom field definitions.
/// </summary>
/// <param name="authContext">Auth context containing customFieldDefinitions</param>
/// <param name="entityName">Entity name to filter custom fields</param>
/// <param name="values">Form values object containing custom field values</param>
/// <returns>Array of objects with fieldKey and fieldValue for submission</returns>
export function buildCustomFieldData(authContext, entityName, values) {
    try {
        let customFieldData = [];
        if (!isNullOrUndefined(authContext) && !isNullOrUndefined(authContext.customFieldDefinitions)) {
            const entityCustomFields = authContext.customFieldDefinitions.filter(
                cfd => cfd.entityName === entityName
            );
            for (let i = 0; i < entityCustomFields.length; i++) {
                const fieldDef = entityCustomFields[i];
                customFieldData.push({
                    fieldKey: fieldDef.fieldKey,
                    fieldValue: values[fieldDef.fieldKey] || ''
                });
            }
        }
        return customFieldData;
    } catch (error) {
        console.log('Error in buildCustomFieldData: ', error);
        return [];
    }
}

/// <summary>
/// Waits for a specific cache key to be populated in Zustand store.
/// Uses reactive subscribe pattern with polling fallback for reliability.
/// </summary>
/// <param name="useStore">Zustand store instance with apiResponseCache</param>
/// <param name="cacheKey">The cache key to wait for (e.g., 'GetCustomerLiteList')</param>
/// <param name="timeout">Max wait time in ms (default: 1000)</param>
/// <param name="pollInterval">Polling interval in ms (default: 10)</param>
/// <returns>Promise<boolean> - true if cache populated, false if timeout</returns>
export async function waitForCacheKey(useStore, cacheKey, timeout = 1000, pollInterval = 10) {
    const maxAttempts = Math.ceil(timeout / pollInterval);
    
    return new Promise((resolve) => {
        let resolved = false;
        let attempts = 0;
        
        // 1. Reactive approach: Subscribe to store changes
        let unsubscribe = null;
        unsubscribe = useStore.subscribe(
            (state) => state.apiResponseCache[cacheKey],
            (cacheValue) => {
                if (!resolved && !isNullOrUndefined(cacheValue)) {
                    resolved = true;
                    if (unsubscribe) unsubscribe();
                    clearInterval(pollInterval);
                    resolve(true);
                }
            }
        );
        
        // 2. Polling fallback: Check state periodically
        const pollTimeout = setInterval(() => {
            if (resolved) {
                clearInterval(pollTimeout);
                return;
            }
            
            const store = useStore.getState();
            const cacheValue = store.apiResponseCache[cacheKey];
            
            if (!isNullOrUndefined(cacheValue)) {
                resolved = true;
                clearInterval(pollTimeout);
                if (unsubscribe) unsubscribe();
                resolve(true);
            }
            
            attempts++;
            if (attempts >= maxAttempts) {
                resolved = true;
                clearInterval(pollTimeout);
                if (unsubscribe) unsubscribe();
                resolve(false);
            }
        }, pollInterval);
    });
}